import React from "react";
import { Switch, Route } from "react-router-dom";
import HotelPackages from "pages/module/packages/HotelPackages";
import HotelPackageDetail from "pages/module/packages/HotelPackageDetail";
import PackageInfo from "pages/module/packages/PackageInfo";

const PackagesLayout = (props) => {
  const { ...rest } = props;
  return (
    <div>
      <props.appconst.postLoginNavbar  {...rest} isSearchPage={true} showServices={true} />
      <div style={{ background: "#ffffff", paddingTop: 0, minHeight: "80vh" }}>
        <Switch>
          <Route path="/packages/categories" exact component={HotelPackages} />
          <Route
            path="/packages/details"
            exact
            component={HotelPackageDetail}
          />
          <Route path="/packages/packageinfo" exact component={PackageInfo} />
          <Route
            path="/packages/packageinfo/:packageId"
            component={PackageInfo}
          />
        </Switch>
      </div>

      <props.appconst.pageFooter appconst={props.appconst}/>
    </div>
  );
};

export default PackagesLayout;
